import apiHelper from '../../helper/ApiHelper';

const AdminHeadService = {

  async getHeads() {
    try {
      return await apiHelper('/admin/head');
    } catch (error) {
      console.error('Error fetching heads:', error);
      throw error;
    }
  },
  async getHeadDetails(headId) {
    try {
      return await apiHelper(`/admin/head/${headId}`);
    } catch (error) {
      console.error('Error fetching head details:', error);
      throw error;
    }
  },
};

export default AdminHeadService;